<template>
  <div>
    <div class="grid grid-cols-1 gap-4 max-h-[60vh] overflow-y-auto">
      <div class="grid grid-cols-2 px-4 gap-4 mb-6">
        <div>
          <p class="font-semibold">Date & Time reviewed and published:</p>
          <p>{{ formattedTimestamp(firstTest?.updated_at) }}</p>
        </div>
        <div>
          <p class="font-semibold">Results sent to:</p>
          <p>{{ firstTest?.requested_by?.Username }}</p>
        </div>
      </div>
      <div v-for="(test, index) in filteredRequests" :key="index" class="mb-8">
        <h2 class="text-lg font-bold mb-4">{{ test.imaging_type?.name }}</h2>
        <div class="grid grid-cols-2 px-4 gap-4 mb-6">
          <div class="space-y-4">
            <div>
              <p class="font-semibold">Requesting Doctor</p>
              <p>{{ test.requested_by?.Username }}</p>
            </div>
            <div>
              <p class="font-semibold">Reviewer/Radiologist</p>
              <p>{{ test.radiology_results[0]?.filled_by?.Username }}</p>
            </div>
            <div class="p-3 bg-gray-50 rounded border border-gray-200">
              <p class="text-xs font-semibold text-gray-500 uppercase">Findings</p>
              <p class="text-sm text-gray-800 mt-1 whitespace-pre-line">{{ test.radiology_results[0]?.findings || '-' }}</p>
            </div>
            <div v-if="test.radiology_results[0]?.recommendation" class="p-3 bg-gray-50 rounded border border-gray-200">
              <p class="text-xs font-semibold text-gray-500 uppercase">Recommendation</p>
              <p class="text-sm text-gray-800 mt-1 whitespace-pre-line">{{ test.radiology_results[0].recommendation }}</p>
            </div>
            <div v-if="test.radiology_results[0]?.conclusion" class="p-3 bg-gray-50 rounded border border-gray-200">
              <p class="text-xs font-semibold text-gray-500 uppercase">Conclusion</p>
              <p class="text-sm text-gray-800 mt-1 whitespace-pre-line">{{ test.radiology_results[0].conclusion }}</p>
            </div>
            <div v-if="test.radiology_results[0]?.notes">
              <p class="font-semibold">Notes:</p>
              <p>{{ test.radiology_results[0].notes }}</p>
            </div>
          </div>
          <div>
            <p class="font-semibold">Attached Reports:</p>
            <div class="mt-2 p-2 border rounded-lg bg-gray-50">
              <div
                v-for="(file, fileIndex) in test.radiology_results[0]?.url"
                :key="fileIndex"
                @click="downloadFile(file.url)"
                class="flex justify-between items-center mb-2">
                <div class="flex items-center gap-2">
                  <span class="text-red-500">{{ file.filename?.split('.').pop().toUpperCase() }}</span>
                  <span>{{ file.filename || 'Lab Report' }}</span>
                </div>
                <button
                  class="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300 flex items-center">
                  <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </button>
              </div>
              <div v-if="!test.radiology_results[0]?.url || test.radiology_results[0]?.url.length === 0">No Attachment</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'RadiologyReport',
  props: {
    requests: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      fileName: '',
      labForm: {
        fileName: ''
      },
      tests: [],
      firstTest: null
    };
  },
  computed: {
    filteredRequests() {
      const completeTests = this.requests.filter(item => item.status?.code === "ST-013");
      if (completeTests.length > 0) {
        this.firstTestDetails(completeTests[0]);
      }
      return completeTests;
    }
  },
  mounted() {
    this.$emit("mounted", "SendResultsTab");
  },
  methods: {
    formattedTimestamp(dateString) {
      const options = {
        weekday: 'long', // "Friday", "Monday"
        year: "numeric", // "2025"
        month: "long", // "January"
        day: "numeric", // "22"
        hour: "numeric", // "1 PM"
        minute: "numeric", // "43"
        hour12: true, // 12-hour time format
      };

      // parse as UTC
      const utcDate = new Date(dateString);


      const date = new Date(utcDate.getTime());

      return date.toLocaleString("en-US", options);
    },
    firstTestDetails(test) {
      this.firstTest = test;
    },
    async downloadFile(fileUrl) {
      console.log("Downloading file:", fileUrl);
      try {
        const response = await axios.get(fileUrl, { responseType: "blob" });
        let fileName = fileUrl.split("/").pop().split("?")[0];
        const contentDisposition = response.headers["content-disposition"];
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match) fileName = match[1];
        }
        const blob = new Blob([response.data]);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading file:", error);
        this.$toast.error("Failed to download file.");
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>